import * as React from "react";
import styled from "styled-components";

const StyledSVG = styled.svg`
  fill: currentColor;
`;

export const Svg: React.FC<Omit<React.SVGProps<SVGSVGElement>, "ref">> = ({
  children,
  ...props
}) => <StyledSVG {...props}>{children}</StyledSVG>;
